'use strict';

import $ from "jquery";
import { gsap } from "gsap";

$(document).ready(function() {
  const $toggle = $(".toggle");
  const $overlay = $(".nav-overlay");
  const $darkBg = $(".nav-overlay .bg-dark-nav"); // ✅ correct class
  const $whiteBg = $(".nav-overlay .bg-white");
  const $menuItems = $(".menu-item");
  let menuOpen = false;

  // GSAP timeline for smooth entrance animation
  const tl = gsap.timeline({ paused: true, reversed: true });

  tl.set($overlay, { display: "block" })
    // Left panel slides in from left
    .fromTo($darkBg, 
      { x: "-100%" }, 
      { x: "0%", duration: 0.6, ease: "power3.out" }
    )
    // Right panel slides in from right
    .fromTo($whiteBg, 
      { x: "100%" }, 
      { x: "0%", duration: 0.6, ease: "power3.out" }, "<"
    )
    // Menu items fade and slide in
    .from($menuItems, 
      { x: 50, opacity: 0, stagger: 0.1, duration: 0.4, ease: "power3.out" },
      "-=0.3"
    );

  // Toggle menu open/close
  $toggle.on("click", function() {
    $(this).toggleClass("activate");
    menuOpen = !menuOpen;

    if (menuOpen) {
      tl.play();
    } else {
      tl.reverse();
    }
  });

  // Close menu on item click
  $menuItems.on("click", function() {
    if (menuOpen) $toggle.trigger("click");
  });
});
